import { NAME_SPACE } from './config';
import Advertisement from './AdvertisementCarousel.vue';

export default {
    name: NAME_SPACE,
    components: {
        'advertisements-carousel': Advertisement,
    },
};
